import {computed} from "mobx";
import {StandingsTabModel} from "../standings.tab-model";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {CompetitorStandingsPageLinkModel} from "../../../../../containers/competitor-container/pages/standings-page/models/competitor.standings-page.link-model";
import {NEW_COMPETITOR_CONTAINER} from "../../../../../containers/competitor-container/competitor-container.consts";

export class CompetitorStandingsPageTabModel extends StandingsTabModel {
  @computed get linkModel(): CompetitorStandingsPageLinkModel {
    const linkModel: CompetitorStandingsPageLinkModel = new CompetitorStandingsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, NEW_COMPETITOR_CONTAINER.FILTERS.standings, null, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === NEW_COMPETITOR_CONTAINER.FILTERS.standings && this.currentLinkModel.hashParams.brackets !== NEW_COMPETITOR_CONTAINER.FILTERS.brackets
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competitor;
  }

  get elementId(): String {
    return 'navigation-tabs_competitor_standings';
  }
}
